import { cn } from '@virginexperiencedays/tailwind';

import { forwardRef, type HTMLAttributes } from 'react';

export const PurchasePanel = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ children, className, ...rest }, ref) => (
    <section
      ref={ref}
      className={cn(
        'bg-background-page overflow-hidden',
        'border-border-neutral-faded dark:border-persistent-text-light rounded-lg border border-solid lg:rounded-lg lg:border',
        'shadow-[0px_20px_24px_-5px_rgba(0,0,0,0.1),_0px_10px_10px_-5px_rgba(0,0,0,0.06)] lg:shadow-[0px_20px_24px_-5px_rgba(0,0,0,0.1),_0px_10px_10px_-5px_rgba(0,0,0,0.06)]',
        className
      )}
      {...rest}
    >
      {children}
    </section>
  )
);
PurchasePanel.displayName = 'PurchasePanel';
